module.exports = __webpack_public_path__ + "img/kommune-1439.cd86ad05.svg";